const videoSrc =
  'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4';

export { videoSrc };
